import React from "react";
import Home from "./screens/home/index";
export default function App() {
  return (
    <div>
      <Home />
    </div>
  );
}
